import { localStorageService } from "../../../services/localStorageService";

/*
    Load style sheet into the given head element.
*/
export const loadStyle = (href: string, head: HTMLHeadElement) => {
    const css = document.createElement("link");

    css.rel = "stylesheet";
    css.href = href;

    head.appendChild(css);
};

/*
    Load script into the given head element.
*/
export const loadScript = (src: string, head: HTMLHeadElement) => {
    const js = document.createElement("script");

    js.type = "text/javascript";
    js.src = src;

    head.appendChild(js);
};

/*
    Load script into the given head element.
*/
export const getBase = () =>
    window.isFromDesktop || window.isFromUiWrapper ? localStorageService.getItem("lms-mobile-base") ?? "" : "";
